import PropTypes from 'prop-types';
import {Grid, Popup, Message, Icon} from 'semantic-ui-react';

import styles from './Advanced.module.scss';

export default function Advanced({drupalSiteConfig}) {
  return (
    <Grid centered stackable className={styles.Advanced}>
      <Grid.Row columns={2}>
        <Grid.Column textAlign="right" width={5} className={styles.Labels}>
          <div className="field">
            <Popup
              content="The quality of service (QoS) class specifies the website's performance and availability requirements. The default value is 'standard'"
              position="left center"
              trigger={<label>Quality of Service class</label>}
            />
          </div>
        </Grid.Column>
        <Grid.Column textAlign="left" width={11}>
          {drupalSiteConfig.qosClass}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={2}>
        <Grid.Column textAlign="right" width={5} className={styles.Labels}>
          <div className="field">
            <Popup
              content="The database class specifies the kind of database that the website needs, among those supported by the cluster. The default value is 'standard'"
              position="left center"
              trigger={<label>Database class</label>}
            />
          </div>
        </Grid.Column>
        <Grid.Column textAlign="left" width={11}>
          {drupalSiteConfig.databaseClass}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={2}>
        <Grid.Column textAlign="right" width={5} className={styles.Labels}>
          <div className="field">
            <Popup
              content={
                <div>
                  Add extra modules to your website with Composer through a GitLab repository,
                  following{' '}
                  <a
                    href="https://drupal.docs.cern.ch/development/custom-modules#installing-modules"
                    target="_blank"
                    rel="noreferrer"
                  >
                    this documentation
                  </a>
                </div>
              }
              position="left center"
              trigger={<label>Configuration repository</label>}
              hoverable
            />
          </div>
        </Grid.Column>
        <Grid.Column textAlign="left" width={11}>
          {drupalSiteConfig.extraConfigurationRepo ? (
            <a href={drupalSiteConfig.extraConfigurationRepo} target="_blank" rel="noreferrer">
              {drupalSiteConfig.extraConfigurationRepo}
            </a>
          ) : (
            'None'
          )}
        </Grid.Column>
      </Grid.Row>
      {drupalSiteConfig.gitlabWebhookURL !== undefined && (
        <Grid.Row columns={2}>
          <Grid.Column textAlign="right" width={5} className={styles.Labels}>
            <div className="field">
              <Popup
                content={
                  <div className="content">
                    This URL triggers the rebuild of the site after its configuration changes in the
                    GitLab repository specified by "Configuration repository" property. It should be
                    copied to GitLab, following{' '}
                    <a
                      href="https://drupal.docs.cern.ch/development/custom-modules#installing-modules"
                      target="_blank"
                      rel="noreferrer"
                    >
                      the documentation
                    </a>
                  </div>
                }
                position="left center"
                trigger={<label>GitLab webhook URL</label>}
                hoverable
              />
            </div>
          </Grid.Column>
          <Grid.Column textAlign="left" width={11}>
            {drupalSiteConfig.gitlabWebhookURL}
          </Grid.Column>
        </Grid.Row>
      )}
      <Grid.Row>
        <Message info>
          <Icon name="info" />
          <a
            href="https://cern.service-now.com/service-portal?id=sc_cat_item&name=request&se=Drupal-Service"
            target="_blank"
            rel="noreferrer"
          >
            In order to change any of the above configuration parameters please open a SNOW ticket
          </a>
          .
        </Message>
      </Grid.Row>
    </Grid>
  );
}

Advanced.propTypes = {
  drupalSiteConfig: PropTypes.object.isRequired,
};
